import React, { useContext } from 'react';
import { IAppContext, AppContext } from 'appState/appContext';
import { IWatchContext, WatchContext } from '../../watchState/watchContext';
import { List } from './List/List';
import { PaginationComponent } from 'components/PaginationComponent/PaginationComponent';
import NoResultsFound from 'components/NoResultsFound/NoResultsFound';
import style from './Watches.module.scss';

export const Categories: React.FC = () => {
	const { isLoading } = useContext<IAppContext>(AppContext);
	const { changeCurrentPage, watches, currentPage, countOfItems } = useContext<IWatchContext>(WatchContext);

	return (
		<>
			{watches.count ? (
				<div className={style.container} data-test="Categories">
					<List />
					<PaginationComponent
						currentPage={currentPage}
						countOfItems={countOfItems}
						entitiesCount={watches.count}
						changeCurrentPage={changeCurrentPage}
					/>
				</div>
			) : (
				<NoResultsFound isVisible={!isLoading} />
			)}
		</>
	);
};
